import { render } from "./AuthComponent.vue?vue&type=template&id=6b7f8f4e&scoped=true"
import script from "./AuthComponent.vue?vue&type=script&lang=js"
export * from "./AuthComponent.vue?vue&type=script&lang=js"

import "./AuthComponent.vue?vue&type=style&index=0&id=6b7f8f4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b7f8f4e"]])

export default __exports__